export default __webpack_public_path__ + "static/id-scan-37a1432a666bf7ca513b2b1d263e3a6c.svg";